/* eslint-disable */
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDeCH from '@angular/common/locales/de-CH';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, inject, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/* Angular Material */
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/* CONFIG */
import SDX_ICON_NAMES from '@assets/icons/sdx/sdx-icons.json';
import { UsersService } from '@common-services/api/users.service';
import { ErrorHandlingService } from '@common-services/log/error-handling.service';
import { GlobalLoggingService } from '@common-services/log/global-logging.service';
import { LoggingRequestService } from '@common-services/log/logging-request.service';
import { LoggingService } from '@common-services/log/logging.service';
import { WindowRefService } from '@common-services/ui/window-ref.service';
/* Custom Services */
import { RequestInterceptorProviders } from '@common-services/util/requestinterceptors/request-interceptor.providers';
import { OWL_DATE_TIME_LOCALE } from '@danielmoncada/angular-datetime-picker';
import { AppComponent } from '@dice/app.component';
import { MainNavigationHeaderComponent } from '@dice/app/components/atoms/main-navigation-header/main-navigation-header.component';
import { NavigationTitleComponent } from '@dice/app/components/atoms/navigation/navigation-title/navigation-title.component';
import { ProfileBadgeComponent } from '@dice/app/components/atoms/profile-badge/profile-badge.component';
import { ProfileNotificationEntryComponent } from '@dice/app/components/atoms/profile-notification-entry/profile-notification-entry.component';
import { FullscreenLoaderComponent } from '@dice/app/components/molecules/fullscreen-loader/fullscreen-loader.component';
import { NavigationBarDesktopEditComponent } from '@dice/app/components/molecules/navigation/navigation-bar-desktop-edit/navigation-bar-desktop-edit.component';
import { NavigationBarDesktopManualComponent } from '@dice/app/components/molecules/navigation/navigation-bar-desktop-manual/navigation-bar-desktop-manual.component';
import { NavigationBarDesktopToggleComponent } from '@dice/app/components/molecules/navigation/navigation-bar-desktop-toggle/navigation-bar-desktop-toggle.component';
import { NavigationElementComponent } from '@dice/app/components/molecules/navigation/navigation-element/navigation-element.component';
import { ProfileFlyOutMenuComponent } from '@dice/app/components/molecules/profile-fly-out-menu/profile-fly-out-menu.component';
import { ScNotificationBarComponent } from '@dice/app/components/molecules/sc-notification-bar/sc-notification-bar.component';
import { BottomBarComponent } from '@dice/app/components/organisms/bottom-bar/bottom-bar.component';
import { MainNavigationComponent } from '@dice/app/components/organisms/main-navigation/main-navigation.component';
import { NavigationBarDesktopComponent } from '@dice/app/components/organisms/navigation-bar/navigation-bar-desktop/navigation-bar-desktop.component';
import { ProfileHeaderComponent } from '@dice/app/components/organisms/profile-header/profile-header.component';
import { TopBarComponent } from '@dice/app/components/organisms/top-bar/top-bar.component';
import { TableComponentsModule } from '@dice/app/components/table-components.module';
/* Components */
import { DiceComponent } from '@dice/app/components/view/dice.component';
import { ContentBarContentOutletDirective } from '@dice/app/directives/content-bar/content-bar-content-outlet.directive';
/* Shared Modules */
import { CommonComponentsModule } from '@dice/app/shared-components/common-components.module';
import { ImportDialog } from '@dice/app/shared-components/molecules/import/import.dialog';
import { MessageDialog } from '@dice/app/shared-components/molecules/message/message.dialog';
/* Shared Components */
import { ContentBarComponent } from '@dice/app/shared-components/organisms/content-bar/content-bar.component';
import { BudaState } from '@dice/app/store/buda/buda.state';
import { NotificationsState } from '@dice/app/store/notifications/notifications.state';
import { ProfileState } from '@dice/app/store/profile/profile.state';
/* STORE */
import { RouterState } from '@dice/app/store/router/router.state';
import { SearchState } from '@dice/app/store/search/search.state';
import { SubscriptionsState } from '@dice/app/store/subscriptions/subscriptions.state';
import { BottomBarViewState } from '@dice/app/store/view/bottom-bar/bottom-bar-view.state';
import { ButtonBarViewState } from '@dice/app/store/view/button-bar/button-bar-view.state';
import { ContentBarViewState } from '@dice/app/store/view/content-bar/content-bar-view.state';
import { NavigationBarViewState } from '@dice/app/store/view/navigation-bar/navigation-bar-view.state';
import { ViewState } from '@dice/app/store/view/view.state';
import { API_OPTIONS, ENV, ICON_NAMES, REVISION, VERSION } from '@dice/config.tokens';
import { EnvironmentProvider } from '@dice/environments/environments';
/* States */
import { APP_STATES } from '@dice/router/app.states';
import { DICE_STATE } from '@dice/router/dice.states';
import { otherwiseRuleHandler, uiRouterConfigFn } from '@dice/router/router.config';
import { LOGIN_MODULE_STATE } from '@login/router/login.module-states';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsDispatchPluginModule } from '@ngxs-labs/dispatch-decorator';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';
import { UIRouterModule } from '@uirouter/angular';
/* Services */
import { AngularSplitModule } from 'angular-split';
import { CookieService } from 'ngx-cookie-service';
/* LOGGING */
import { LoggerModule, NgxLoggerLevel, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { withNgxsResetPlugin } from 'ngxs-reset-plugin';

registerLocaleData(localeDeCH);

const STATES = [LOGIN_MODULE_STATE, DICE_STATE, ...APP_STATES];

const isProduction = EnvironmentProvider.isProd;

export let AppModuleInjector: Injector = null;

function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './translations/', '.json');
}

/* eslint-enable */

@NgModule({
  providers: [
    {
      provide: ENV,
      useValue: EnvironmentProvider.environment,
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', color: 'primary' } },
    { provide: ICON_NAMES, useValue: SDX_ICON_NAMES },
    { provide: API_OPTIONS, useValue: { retries: 3, timeout: 30000 } },
    { provide: VERSION, useValue: '13.9.24' },
    { provide: REVISION, useValue: 'r0' },
    { provide: LOCALE_ID, useValue: 'de-CH' },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'de-CH' },
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    // { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 0,
        hideDelay: 0,
        touchendHideDelay: 1500,
        disableTooltipInteractivity: true,
      },
    },
    LoggingService,
    RequestInterceptorProviders,
    CookieService,
    UsersService,
    WindowRefService,
    { provide: ErrorHandler, useClass: ErrorHandlingService },
    provideHttpClient(withInterceptorsFromDi()),
    withNgxsResetPlugin(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  imports: [
    LoggerModule.forRoot(
      {
        serverLoggingUrl: EnvironmentProvider.environment.logEndpoint,
        level: EnvironmentProvider.environment.logLevel,
        serverLogLevel: NgxLoggerLevel.OFF,
        disableConsoleLogging: isProduction,
        proxiedSteps: 1,
      },
      {
        serverProvider: {
          provide: TOKEN_LOGGER_SERVER_SERVICE,
          useClass: LoggingRequestService,
        },
      },
    ),
    NgxsStoragePluginModule.forRoot({ keys: [ProfileState, SearchState] }),
    NgxsModule.forRoot(
      [
        RouterState,
        ProfileState,
        SubscriptionsState,
        NotificationsState,
        ButtonBarViewState,
        BottomBarViewState,
        ContentBarViewState,
        NavigationBarViewState,
        ViewState,
        BudaState,
        SearchState,
      ],
      {
        developmentMode: !isProduction,
        selectorOptions: {
          injectContainerState: false,
        },
      },
    ),
    AngularSplitModule,
    CommonComponentsModule,
    CommonModule,
    TableComponentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatProgressSpinnerModule,
    UIRouterModule.forRoot({
      states: STATES,
      useHash: true,
      config: uiRouterConfigFn,
      otherwise: otherwiseRuleHandler,
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({ name: 'dice-frontend', disabled: false, actionsBlacklist: [] }),
    NgxsDispatchPluginModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    ImportDialog,
    MessageDialog,
    TopBarComponent,
    BottomBarComponent,
    ProfileBadgeComponent,
    ProfileFlyOutMenuComponent,
    ProfileHeaderComponent,
    ProfileNotificationEntryComponent,
    FullscreenLoaderComponent,
    DiceComponent,
    NavigationTitleComponent,
    NavigationBarDesktopToggleComponent,
    NavigationBarDesktopEditComponent,
    NavigationBarDesktopManualComponent,
    NavigationElementComponent,
    NavigationBarDesktopComponent,
    MainNavigationComponent,
    MainNavigationHeaderComponent,
    ScNotificationBarComponent,
    ContentBarContentOutletDirective,
    ContentBarComponent,
  ],
  exports: [ScNotificationBarComponent, ContentBarContentOutletDirective],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    const _injector = inject(Injector);
    const globalLoggingService = inject(GlobalLoggingService);
    const loggingService = inject(LoggingService);

    AppModuleInjector = _injector;
    globalLoggingService.initGlobalLogger(loggingService);
  }
}
